/* eslint-disable camelcase */
import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import {
  DisbursementValidationConfigService,
  Wealthlane_Shared_Hosting_Dtos_KeyValueSettings_DisbursementKeyValueSettingsDto,
} from '@wealthlane/api-services/wealthlane-award-settlement-service';

const usePostDisbursementConfiguration = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseMutationResult<
  Wealthlane_Shared_Hosting_Dtos_KeyValueSettings_DisbursementKeyValueSettingsDto | undefined,
  unknown,
  any
> => {
  const queryClient = useQueryClient();
  return useMutation(
    async (
      payload: Wealthlane_Shared_Hosting_Dtos_KeyValueSettings_DisbursementKeyValueSettingsDto
    ) => {
      return await handleRequest(
        DisbursementValidationConfigService.postApiAwardSettlementApiAppDisbursementValidationConfigUpsertValidationRule(
          payload
        )
      );
    },
    {
      onSuccess: async (response: any) => {
        if (response) {
          await queryClient.invalidateQueries('getDisbursementConfiguration');
          toast.success(
            <ToastComponent label='Success' message={`Disbursement Configuration edited.`} />
          );
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostDisbursementConfiguration;
